exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-27d5445b] {\n  width: 100%;\n  height: 100%;\n}\n.bulkUpdate[data-v-27d5445b] {\n  width: 100%;\n  height: 100%;\n}\n", ""]);

// exports
